import React from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon, MagnifyingGlassIcon, AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const PerfumeEmptyState = ({ onStartFinder, onClearFilters, hasFilters = false }) => {
  return (
    <div className="text-center py-12 px-4 max-w-2xl mx-auto">
      {/* Icon */}
      <div className="mb-6">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-purple-100 to-pink-100 mb-4">
          <span className="text-5xl">🌸</span>
        </div>
      </div>

      {/* Title & Description */}
      <h3 className="text-2xl font-bold text-gray-900 mb-3">
        {hasFilters ? 'לא נמצאו בשמים מתאימים' : 'טרם הוספת בשמים'}
      </h3>
      
      <p className="text-lg text-gray-600 mb-8">
        {hasFilters 
          ? 'נסה לשנות את הפילטרים או החיפוש למציאת הבושם המושלם'
          : 'הקטלוג שלנו ריק כרגע, אבל אנחנו עובדים על זה!'
        }
      </p>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        {hasFilters ? (
          <>
            <button
              onClick={onClearFilters}
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-full font-semibold hover:bg-gray-50 transition-all duration-300"
            >
              <AdjustmentsHorizontalIcon className="h-5 w-5 ml-2" />
              נקה פילטרים
            </button>
            
            {onStartFinder && (
              <button
                onClick={onStartFinder}
                className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full font-semibold hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                <SparklesIcon className="h-5 w-5 ml-2" />
                מצא את הבושם המושלם
              </button>
            )}
          </>
        ) : (
          <>
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full font-semibold hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <MagnifyingGlassIcon className="h-5 w-5 ml-2" />
              גלה בשמים
            </Link>
            
            {onStartFinder && (
              <button
                onClick={onStartFinder}
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-purple-600 text-purple-600 rounded-full font-semibold hover:bg-purple-50 transition-all duration-300"
              >
                <SparklesIcon className="h-5 w-5 ml-2" />
                מוצא בשמים
              </button>
            )}
          </>
        )}
      </div>

      {/* Popular Suggestions */}
      {hasFilters && (
        <div className="mt-12 pt-8 border-t border-gray-200">
          <h4 className="text-sm font-semibold text-gray-700 mb-4">חיפושים פופולריים:</h4>
          <div className="flex flex-wrap gap-2 justify-center">
            {['בשמים פרחוניים', 'בשמים לגברים', 'בשמים מזרחיים', 'בשמים לערב', 'בשמים רעננים'].map((tag) => (
              <Link
                key={tag}
                to={`/products?search=${encodeURIComponent(tag)}`}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-purple-100 hover:text-purple-700 transition-colors duration-200"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Features */}
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm">
        <div>
          <div className="text-3xl mb-2">✨</div>
          <div className="font-semibold text-gray-900 mb-1">בשמים אותנטיים</div>
          <div className="text-gray-600">100% מקורי מיבואן רשמי</div>
        </div>
        <div>
          <div className="text-3xl mb-2">🎁</div>
          <div className="font-semibold text-gray-900 mb-1">משלוח חינם</div>
          <div className="text-gray-600">על הזמנות מעל ₪200</div>
        </div>
        <div>
          <div className="text-3xl mb-2">💬</div>
          <div className="font-semibold text-gray-900 mb-1">ייעוץ מקצועי</div>
          <div className="text-gray-600">צוות מומחים לשירותכם</div>
        </div>
      </div>
    </div>
  );
};

PerfumeEmptyState.propTypes = {
  onStartFinder: PropTypes.func,
  onClearFilters: PropTypes.func,
  hasFilters: PropTypes.bool,
};

export default PerfumeEmptyState;

